export default __webpack_public_path__ + "static/media/stopwatch.d96a0385.svg";